// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"fcccb7f0","839":"846ff4a5"}[chunkId] + ".chunk.css";
};